import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxPermissionsModule } from 'ngx-permissions';
import { CreateTaskComponent } from './create-task/create-task.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { MAT_DECLARATIONS, MAT_PROVIDERS } from 'src/app/shared/material.module';
import { NotificationModalComponent } from './notification-modal/notification-modal.component';
import { TaskDetailsComponent } from './task-details/task-details.component';
import { DocAccessPermissionComponent } from './doc-access-permission/doc-access-permission.component';
import { EndorseVerifyOtpComponent } from './task-details/endorse-verify-otp/endorse-verify-otp.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { EditApproversEndorsersDialogComponent } from '../home/tasks/edit-approvers-endorsers-dialog/edit-approvers-endorsers-dialog.component';
import { CommentDialogue } from '../home/tasks/comment-dialogue/comment-dialog.component';
import { StarRatingComponent } from '../home/events/event-feedback/star-rating/star-rating.component';
import { MatIconModule, MatSnackBarModule } from '@angular/material';


@NgModule({
  declarations: [
   CreateTaskComponent,
   NotificationModalComponent,
   TaskDetailsComponent,
   DocAccessPermissionComponent,
   EndorseVerifyOtpComponent,
   EditApproversEndorsersDialogComponent,
   CommentDialogue,
   StarRatingComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    NgxPermissionsModule,
    SharedModule,
    ...MAT_DECLARATIONS,
    RouterModule,
    NgxPaginationModule,
    MatSnackBarModule,
    MatIconModule
  ],
  exports: [
    CreateTaskComponent,
    NotificationModalComponent,
    TaskDetailsComponent,
    StarRatingComponent,
    MatSnackBarModule,
    MatIconModule
  ],
  entryComponents: [
    NotificationModalComponent,
    DocAccessPermissionComponent,
    EndorseVerifyOtpComponent,
    CommentDialogue,
    EditApproversEndorsersDialogComponent
  ],
  providers: [...MAT_PROVIDERS],
  bootstrap: []
})
export class CommonComponentsModule { }
